import { apiMapper } from "./ApiMapper";

const ClientAPI = {
  LIST: (axiosPrivate, pageNumber, pageSize) => {
    return axiosPrivate.get(
      `${apiMapper.client.list}?page=${pageNumber}&page_size=${pageSize}&business_unit=business_unit_2`
    );
  },
  BUDGET_LIST: (axiosPrivate, pageNumber, pageSize) => {
    return axiosPrivate.get(
      `${apiMapper.client.list}?page=${pageNumber}&page_size=${pageSize}&business_unit=business_unit_1`
    );
  },
  ADD: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.client.add, payload);
  },
  UPDATE: (axiosPrivate, clientId, payload) => {
    return axiosPrivate.patch(`${apiMapper.client.update}${clientId}`, payload);
  },
  ADD_NDA_CONTRACT: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.client.addNdaContract, payload);
  },
  UPDATE_NDA_CONTRACT: (axiosPrivate, contractId, payload) => {
    return axiosPrivate.patch(
      `${apiMapper.client.updateNdaContract}${contractId}/`,
      payload
    );
  },
  DETAIL: (axiosPrivate, clientId) => {
    return axiosPrivate.get(`${apiMapper.client.detail}${clientId}`);
  },
  DELETE: (axiosPrivate, id) => {
    return axiosPrivate.delete(`${apiMapper.client.delete}${id}`);
  },
  CHECK_CLIENT_CONTRACT_NAME: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.client.checkClientContractName, payload);
  },
};
export default ClientAPI;
